import React, { useState } from 'react';
import { Menu, Dropdown, Drawer, Avatar, Divider } from 'antd';
import { PageHeader as AntHeader } from '@ant-design/pro-layout';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { DownOutlined, MailOutlined } from '@ant-design/icons';
import { setSelectedOrganization } from '../redux/reducers/globals/globalActions';
import { applicationLogout } from '../services/LoginServices';
import userLogo from '../assets/images/user.png';
import { FiLogOut, FiUser } from 'react-icons/fi';
import { SIDE_MENUS } from 'constants/app-constants';
import { getFirstLetterFromWords } from 'helpers';
import './pageHeaderStyle.scss';
import './drawer.scss';

export const LogoComponent = () => (
	<Link to="/">
		<img className="logo" src="./logo.png" style={{ height: 40 }} alt="logo" />
		{/* <span>MMT</span> */}
	</Link>
);

const PageHeader = () => {
	const history = useHistory();
	const [placement] = useState('right');
	// const navigate = useNavigate();

	const globalRedux = useSelector((state) => state.globalRedux);
	// const selectedOrganization = useSelector((state) => state.globalRedux?.selectedOrganization);
	const loginRedux = useSelector((state) => state.loginRedux);
	const [open, setOpen] = useState(false);

	const dispatch = useDispatch();

	const showDrawer = () => {
		setOpen(true);
	};

	const onClose = () => {
		setOpen(false);
	};

	const profileMenu = (
		<Menu style={{ width: '150px', marginTop: '10px' }}>
			{/* <Menu.Item className="profile-btn" key="1">
				Profile
			</Menu.Item> */}
			<Menu.Item
				className="logout-button"
				id="logout-button"
				key="2"
				onClick={() => {
					applicationLogout(history);
				}}>
				Logout
			</Menu.Item>
		</Menu>
	);

	const organizationMenu = (
		<Menu>
			{globalRedux?.organizations?.map((org) => (
				<Menu.Item
					key={org?._id}
					// value={selectedOrganization?._id}
					onClick={() => {
						dispatch(setSelectedOrganization(org));
						setTimeout(() => {
							window.location.reload();
						}, 1000);
					}}>
					{org.orgName}
				</Menu.Item>
			))}
		</Menu>
	);

	return loginRedux.isLogged ? (
		<>
			<AntHeader
				className="custom-header"
				title={<LogoComponent />}
				style={{ backgroundColor: '#fff' }}
				extra={[
					<Dropdown overlay={organizationMenu} trigger={['click']}>
						<a style={{ color: 'black', marginRight: '10px' }} onClick={(e) => e.preventDefault()}>
							{globalRedux?.selectedOrganization?.orgName} <DownOutlined />
						</a>
					</Dropdown>,
					// <FiUsers className="pointer-icons page-header-tiles" />,
					<div onClick={showDrawer}>
						{/* <img
							src={userLogo}
							alt="profile"
							className="pointer-icons"
							style={{ borderRadius: '50px', marginRight: '20px' }}
							height="23px"
							width="23px"
						/> */}

						<Avatar className="pointer-icons" style={{ verticalAlign: 'middle', backgroundColor: '#21B478' }} size="default">
							{getFirstLetterFromWords(`${loginRedux?.firstName} ${loginRedux?.lastName}`)}
						</Avatar>
					</div>,
				]}
			/>
			<Drawer
				rootClassName="app-drawer"
				title={
					<div className="title-area">
						<div data-view-component="true" className="AppHeader-logo position-relative">
							{/* <img
							src="https://avatars.githubusercontent.com/u/30047638?v=4"
							alt=""
							height="32"
							width="32"
							data-view-component="true"
							class="avatar circle"
						/> */}
							<Avatar size="default" style={{ verticalAlign: 'middle', backgroundColor: '#21B478' }}>
								{getFirstLetterFromWords(`${loginRedux?.firstName} ${loginRedux?.lastName}`)}
							</Avatar>
						</div>
						<div className="name_role">
							<div className="name">
								{loginRedux?.firstName} {loginRedux?.lastName}
							</div>
							<div className="role">{loginRedux?.mobile}</div>
						</div>
					</div>
				}
				placement={placement}
				// closable={false}
				width="20%"
				onClose={onClose}
				visible={open}
				key={placement}>
				<div className="drawer-container">
					{/* <ul>
					<li>
						<BsPerson />
						<span>Customers</span>
					</li>
					<li>
						<BsPerson />
						<span>Customers</span>
					</li>
					<li>
						<BsPerson />
						<span>Customers</span>
					</li>
				</ul> */}

					<Menu theme="light" mode="inline">
						{/* <Menu.Item
							className="logout-button"
							id="logout-button"
							key="4"
							icon={<FiUser />}
							onClick={() => {
								onClose();
								history.push('/profile');
							}}>
							Profile
						</Menu.Item>
						<Divider /> */}
						{SIDE_MENUS.map((menu, index) => {
							const Icon = menu?.icon || <MailOutlined />;
							return (
								<Menu.Item
									key={menu?.key}
									icon={Icon}
									onClick={() => {
										onClose();
										menu?.route && history.push(menu?.route);
									}}>
									{menu?.name}
								</Menu.Item>
							);
						})}
						<Divider />
						<Menu.Item
							className="logout-button"
							id="logout-button"
							key="5"
							icon={<FiLogOut />}
							onClick={() => {
								onClose();
								applicationLogout();
							}}>
							Logout
						</Menu.Item>
					</Menu>
				</div>
			</Drawer></>
	) : null;
};

export default PageHeader;
